<template>
    <modal name="koin-delete-modal" class="koin-delete-modal"
           :width="'380px'"
           :height="'300px'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <!-- <koin-component :paymentType="`koinDelete`" :memberKey="memberKey" :koinKey="koinKey"></koin-component> -->
        <div class="btn_wrap modal_btn_wrap">
            <el-button class="modal_btn" @click="save()" type="save" :disabled="checkAll">삭제</el-button>
            <el-button class="modal_btn" @click="close()" type="cancel">닫기</el-button>
        </div>
    </modal>
</template>

<script>
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";
    import KoinComponent from "@/components/payment/KoinComponent";

    export default {
        name: "KoinDeleteModal",
        mixins: [],
        components: {
            KoinComponent
        },
        props: {
        },
        provide(){
            return{
                checkAllValidation: this.checkAllValidation
            }
        },
        data() {
            return {
                checkAll:true,
                koinKey:{default: 0},
                memberKey: {default: 0},
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            handlerBeforeOpen(event) {
                if (util.isEmpty(event.params) || util.isEmpty(event.params.memberKey)) {
                    event.stop();
                } else {
                    this.memberKey = event.params.memberKey;
                    this.koinKey= event.params.koinKey
                }
            },
            handlerOpened() {
                this.checkAll=true
            },
            handlerBeforeClose() {
                if(this.$route.path !=  this.$route.fullPath) {
                    this.$router.replace(this.$route.path);
                }
            },
            close(){
                this.$modal.hide('koin-delete-modal');
            },
            save() {
                EventBus.$emit('deleteKoin')
            },
            checkAllValidation(bool){
                this.checkAll = bool
            }
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
